export default "__VITE_ASSET__DXb_LtVi__"